// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpOutlinedSvg from "@ant-design/icons-svg/es/asn/UpOutlined";
import AntdIcon from '../components/AntdIcon';

var UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpOutlinedSvg
  }));
};

UpOutlined.displayName = 'UpOutlined';
export default /*#__PURE__*/React.forwardRef(UpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/UpOutlined.js
// module id = 954
// module chunks = 0